module.exports = __webpack_public_path__ + "img/2_231.3fbc7722.png";